/**
 * Risk Utilities
 *
 * This file contains risk-related utilities for orders:
 * - Risk level to Tag accent color mapping
 */

/**
 * Map risk level to Tag accent color
 */
export const getRiskLevelAccent = (
	riskLevel: string | undefined,
): 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
	if (!riskLevel) return 'neutral';

	const normalizedRiskLevel = riskLevel.toLowerCase();

	switch (normalizedRiskLevel) {
		case 'low':
			return 3; // Green
		case 'medium':
			return 6; // Yellow
		case 'high':
			return 5; // Orange
		case 'very_high':
			return 4; // Red
		default:
			return 'neutral';
	}
};
